import React from 'react'

import statusIndex from 'data/commerce-status-index'

const defaultStatus = { color: '', status: 'ongoing', text: 'Tanımsız' }

const CommerceOrderStatus = (props) => {
	let status = false;
	let statusText = false;

	let statusObject = (props.status && statusIndex[props.status.toString()]) ? statusIndex[props.status.toString()] : defaultStatus;
	status = statusObject.status;
	statusText = statusObject.text;

	if(status) {
	    return (
			<span className={'order-status ' + (props.label ? 'label big ' : '') + status}>
				{!props.label && <i className="status-icon"></i>}<span className="status-text">{statusText}</span>
			</span>
	    )
	}
	else {
		return false;
	}
};

CommerceOrderStatus.defaultProps = {
    exchangeType: '',
    currency: '',
    label: false,
    price: 0,
}

export default CommerceOrderStatus